import React from "react";


const StatsCards = ({ data, variant = "row" }) => (

  <div className={`hm-stats-cards-${variant}`}>
    {data.map((item, index) => (
      <div key={index} className="hm-stats-card">
        <div>
          <div className="hm-stats-label">{item.title}</div>
          <div className={`hm-stats-value hm-stats-value-${item.color}`}>
            {item.content}
          </div>
          <div className="hm-stats-sub">{item.info}</div>
        </div>
        <i>
          <img
            src={`${process.env.REACT_APP_PROJECT_URL}/img/stats-icon-${item.icon}.png`}
            alt="users"
          />
        </i>
      </div>
    ))}
  </div>
);

export default StatsCards;
